/*
  NOTE: This helper exports a custom validation rule for the Vee Validate plugin:
  https://vee-validate.logaretm.com/v4/guide/global-validators
*/



const validateStrongPassword = (rawValue) => {
  if (rawValue == null || rawValue === '') return true;

  const value = rawValue;
  const hasEightCharacters = value.length >= 8;
  const hasLowercase = /[a-z]/.test(value);
  const hasUppercase = /[A-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);

  if (!hasEightCharacters) {
    return 'Must contain at least 8 characters.';
  }

  if (!hasLowercase) {
    return 'Must contain at least 1 lowercase letter.';
  }

  if (!hasUppercase) {
    return 'Must contain at least 1 uppercase letter.';
  }

  if (!hasNumber) {
    return 'Must contain at least 1 number.';
  }

  return true;
};



export default validateStrongPassword;
